import React from 'react';
import CreditFoundationView from 'partial/OfferManager/modules/CreditFoundation/CreditFoundationView';
import {
  CLICK,
  buildAttributes,
} from 'partial/OfferManager/modules/staticModule';
import { useLinkHandler } from 'hook/event.hook';
import { CREDIT_FOUNDATION_ACTION } from 'types/morph.pagePosition.constants';
import { useSeenModulePixel, useViewModule } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';

function CreditFoundationController(props) {
  const onClickApply = () => {
    props.eventHandler(
      CLICK,
      buildAttributes(props, {
        'Click Type': 'Apply',
      }),
    );
  };
  const onLinkClickCallback = useLinkHandler(props.eventHandler);
  const atr = getViewModuleTrackingAttributes(
    CREDIT_FOUNDATION_ACTION,
    props.modulePosition,
  );

  useViewModule(atr);
  const seenPixel = useSeenModulePixel(atr);

  return (
    <CreditFoundationView
      onClickApply={onClickApply}
      onLinkClickCallback={onLinkClickCallback}
      seenPixel={seenPixel}
      {...props}
    />
  );
}

export default CreditFoundationController;
